import React, { useState } from 'react';
import { CircularProgress, Stack, Box, Chip } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useParams } from 'react-router';
import { myConstants } from '../../shares/Constants';
import { useLazyFetchClubRegistrationQuery } from "../../store/club/ClubApi";
import { ClubLogo } from './Logo';

/*
 * die verschiedenen Status und die Farben und Beschreibungen
 * für die Chips
 */
const STATUS_CHIP = {
  [myConstants.clubModel.status.registered]: { label: 'Angemeldet', color: 'success'  },
  [myConstants.clubModel.status.interested]: { label: 'Interessiert', color: 'warning' },
  [myConstants.clubModel.status.cancelled]:  { label: 'Abgesagt', color: 'default'  },
};

export default function SubTitle({ club }) 
{  
  const { year } = useParams();
  const [fetchClubRegistration] = useLazyFetchClubRegistrationQuery( );
  const [clubStatus, setClubStatus] = useState(myConstants.clubModel.status.interested)

  // Auslesen der aktuellen ClubRegistrierung
  React.useEffect( 
    () => {
      if (!club?.id || !year) return;
      fetchClubRegistration(    
        {
          year  : year,
          id    : club.id,
        }  
      ).unwrap(    
      ).then(
        (payload) => setClubStatus(payload.derived_status ?? payload.status)
      ).catch(
        (error) => setClubStatus(myConstants.clubModel.status.interested)
      );
    }, [year, club?.id, fetchClubRegistration]
  );


  if (!club)
  {
    return(

      <CircularProgress />
    );
  }



  const chip = STATUS_CHIP[clubStatus] ?? { label : clubStatus, color: 'default' };

  return(                    
    <Box sx={{ marginBottom:"20px" }}>
      <Stack direction="column" alignItems="center"  spacing={1} > 
        <Stack direction="row" alignItems="center" spacing={1} >
          <ClubLogo key={club.id} year={year} club={club} size={72} />
          <Stack direction="column" alignItems="flex-start" spacing={0.5}> 
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography variant="h3">{club.name}</Typography>    
              <Chip label={chip.label} color={chip.color} size="small" />          
            </Stack>         
            {
              club.is_local 
              ? <Typography variant="h5">Ihr bucht mit Heimvorteil!</Typography>
              : <Typography variant="h5">Willkommen in Hanau!</Typography>
            }
          </Stack>
        </Stack>
      </Stack>          
    </Box>                
  );
}    